import { useRef, useState } from "react";
import { Pause, Play } from "lucide-react";

function Clip({ v, i, slug }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const toggle = () => {
    const el = ref.current;
    if (!el) return;
    if (el.paused) el.play();
    else el.pause();
  };
  const portrait = v.orientation === "portrait";
  return (
    <div
      className={`group relative overflow-hidden rounded-2xl bg-ink ${portrait ? "aspect-[9/16] lg:col-span-1" : "aspect-video lg:col-span-2 lg:aspect-auto lg:h-full"}`}
      data-testid={`video-clip-${slug}-${i}`}
    >
      <video
        ref={ref}
        src={v.src}
        poster={v.poster}
        playsInline
        loop
        muted
        preload="metadata"
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onClick={toggle}
        className="h-full w-full cursor-pointer object-cover"
      />
      <button
        type="button"
        onClick={toggle}
        aria-label={playing ? "Pause" : "Play"}
        data-testid={`video-play-${slug}-${i}`}
        className={`absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-cream/90 text-ink shadow-xl transition-all duration-300 hover:scale-105 ${
          playing ? "opacity-0 group-hover:opacity-100" : "opacity-100"
        }`}
      >
        {playing ? <Pause className="h-6 w-6" /> : <Play className="ml-1 h-6 w-6" />}
      </button>
      <p className="pointer-events-none absolute bottom-4 left-4 rounded-full bg-ink/60 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-cream backdrop-blur">
        {v.title}
      </p>
    </div>
  );
}

export const VideoGallery = ({ videos, slug }) => (
  <div className="border-t border-pine/10 px-6 pb-4 pt-8 md:px-10" data-testid={`video-gallery-${slug}`}>
    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-pine">On location</p>
    <p className="mt-2 text-sm text-moss">Walk the land and fly over the bays — filmed on site.</p>
    <div className="mt-5 grid gap-4 lg:grid-cols-3">
      {videos.map((v, i) => (
        <Clip key={v.src} v={v} i={i} slug={slug} />
      ))}
    </div>
  </div>
);
